import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center h-full py-24 text-center">
      <p className="text-6xl font-bold text-primary opacity-20 mb-4">404</p>
      <h2 className="text-lg font-semibold text-text_primary mb-1">Page not found</h2>
      <p className="text-sm text-text_muted mb-6">The page you're looking for doesn't exist.</p>
      <button
        onClick={() => navigate("/swiftreach/dashboard")}
        className="px-5 py-2.5 rounded-lg text-sm font-medium bg-primary text-white hover:bg-primary_hover transition-colors"
      >
        Go to Dashboard
      </button>
    </div>
  );
}
